import { Image } from "@chakra-ui/image";
import { Flex, Box } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import Link from "next/link";
import { wpStyles } from "../../../theme/wp-styles";

const PlanCard = ({ title, url, logo, fields }) => {
  const { lowestMonthlyRate, productColor } = fields;
  // console.log("Logo", logo);
  return (
    <Link href={url} passHref>
      <Flex
        as="a"
        // border="1px"
        bg={productColor ? productColor : "gray.200"}
        // h={"175px"}
        alignItems={"center"}
        rounded="15px"
        transition={"border, background 0.5s ease"}
        _hover={{
          borderColor: "black",
          opacity: 0.8,
          bg: "black",
        }}
        textDecor="none"
        role="group"
      >
        <Box w="100%">
          {logo ? (
            <Flex
              h="45px"
              alignItems={"center"}
              bg="white"
              p={2}
              border="1px"
              borderColor={productColor ? productColor : "gray.200"}
              roundedTop="15px"
              _groupHover={{
                borderColor: "black",
              }}
              sx={{
                img: {
                  display: "block",
                  mx: "auto",
                  maxH: "100%",
                },
              }}
            >
              <img
                src={logo.url}
                alt={title}
                width={`${logo.width}px`}
                height={`${logo.height}px`}
              />
            </Flex>
          ) : (
            <Box
              as="h4"
              my={0}
              fontSize={"md"}
              color={productColor ? productColor : `content.500`}
              fontWeight="bold"
              textAlign="center"
              mt="2"
            >
              {title}
            </Box>
          )}
          {lowestMonthlyRate && (
            <Flex justifyContent="center" py={2}>
              <Tag
                fontSize={wpStyles.fontSize.sm}
                fontWeight="bold"
                bg="transparent"
                color="white"
              >{`Starting at ${lowestMonthlyRate}`}</Tag>
            </Flex>
          )}
        </Box>
      </Flex>
    </Link>
  );
};

export default PlanCard;
